module.exports = __webpack_public_path__ + "static/img/banner2.95caff4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/banner2.jpg
// module id = tb8L
// module chunks = 0